var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.siteKey.length > 0 && !_vm.isLoading)?_c('VueRecaptcha',{attrs:{"load-recaptcha-script":true,"sitekey":_vm.siteKey},on:{"verify":function($event){return _vm.$emit('verify', true)},"expired":function($event){return _vm.$emit('verify', false)}}}):_c('div',[_vm._v(" Loading... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }